import { createContext, useState } from "react";
import { useDispatch } from "react-redux";
import { isEmpty } from "lodash";

import {
  createRouletteItemService,
  deleteRouletteItemService,
  editRouletteItemService,
  getRouletteItemsService,
} from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";

export const rouletteAdminContext = createContext({
  rouletteItems: [],
  setRouletteItems: () => {},
  roulette: {},
  setRoulette: () => {},
  id: "",
  setId: () => {},
  thumbnail: "",
  setThumbnail: () => {},
  title: "",
  setTitle: () => {},
  description: "",
  setDescription: () => {},
  count: null,
  setCount: () => {},
  weight: null,
  setWeight: () => {},
  isShowModal: null,
  setIsShowModal: () => {},
  isShowDetailsModal: null,
  setIsShowDetailsModal: () => {},
  totalCount: null,
  setTotalCount: () => {},
  pageNumber: null,
  setPageNumber: () => {},
  limit: null,
  setLimit: () => {},
  handleShowModal: () => {},
  handleCloseModal: () => {},
  handleShowDetailsModal: () => {},
  handleCloseDetailsModal: () => {},
  handleGetRouletteItemList: () => {},
  handleCreateRouletteItem: () => {},
  handleEditRouletteItem: () => {},
  handleDeleteRouletteItem: () => {},
});

const RouletteAdminContext = ({ children }) => {
  // Redux Dispatch
  const dispatch = useDispatch();

  const [rouletteItems, setRouletteItems] = useState([]);
  const [roulette, setRoulette] = useState({});
  const [id, setId] = useState("");
  const [thumbnail, setThumbnail] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [count, setCount] = useState("");
  const [weight, setWeight] = useState("");
  const [isShowModal, setIsShowModal] = useState(false);
  const [isShowDetailsModal, setIsShowDetailsModal] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [limit, setLimit] = useState(100);

  const handleResetState = () => {
    setId("");
    setThumbnail("");
    setTitle("");
    setDescription("");
    setCount("");
    setWeight("");
  };

  // Create User Satisfaction Modal Operations
  const handleShowModal = (itemValue) => {
    setIsShowModal(true);
    if (itemValue) {
      setId(itemValue.id);
      setThumbnail(itemValue.thumbnail);
      setTitle(itemValue.title);
      setDescription(itemValue.description);
      setCount(itemValue.count);
      setWeight(itemValue.weight);
    }
  };
  const handleCloseModal = () => {
    setIsShowModal(false);
    handleResetState();
  };

  // Details User Satisfaction Modal Operations
  const handleShowDetailsModal = (value) => {
    setIsShowDetailsModal(true);
    setRoulette(value);
  };
  const handleCloseDetailsModal = () => {
    setIsShowDetailsModal(false);
    setRoulette({});
  };

  // Handle Get User Satisfaction Item List Method
  const handleGetRouletteItemList = async (event) => {
    event?.preventDefault();
    const isSearch = !isEmpty(event);

    const objData = {
      offset: ((isSearch ? 1 : pageNumber) - 1) * limit,
      limit,
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getRouletteItemsService(objData);
      if (status === 200) {
        setRouletteItems(data.results);
        setTotalCount(data.count);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Create User Satisfaction Item Method
  const handleCreateRouletteItem = async (event) => {
    event?.preventDefault();

    const objData = { thumbnail, title, description, count, weight };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await createRouletteItemService(objData);
      if (status === 201) {
        toastSuccessMessage("آیتم با موفقیت ایجاد شد");
        handleGetRouletteItemList();
        handleCloseModal();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Edit User Satisfaction Item Method
  const handleEditRouletteItem = async (event) => {
    event?.preventDefault();

    const objData = { id, thumbnail, title, description, count, weight };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await editRouletteItemService(objData);
      if (status === 200) {
        toastSuccessMessage("آیتم با موفقیت ویرایش شد");
        handleGetRouletteItemList();
        handleCloseModal();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Delete User Satisfaction Item Method
  const handleDeleteRouletteItem = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await deleteRouletteItemService(id);
      if (status === 204) {
        toastSuccessMessage(`آیتم  ${id} با موفقیت حذف شد`);
        handleGetRouletteItemList();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <rouletteAdminContext.Provider
      value={{
        rouletteItems,
        setRouletteItems,
        roulette,
        setRoulette,
        totalCount,
        setTotalCount,
        pageNumber,
        setPageNumber,
        limit,
        setLimit,
        id,
        setId,
        thumbnail,
        setThumbnail,
        title,
        setTitle,
        description,
        setDescription,
        count,
        setCount,
        weight,
        setWeight,
        isShowModal,
        setIsShowModal,
        isShowDetailsModal,
        setIsShowDetailsModal,
        handleShowDetailsModal,
        handleCloseDetailsModal,
        handleShowModal,
        handleCloseModal,
        handleGetRouletteItemList,
        handleCreateRouletteItem,
        handleEditRouletteItem,
        handleDeleteRouletteItem,
      }}
    >
      {children}
    </rouletteAdminContext.Provider>
  );
};

export default RouletteAdminContext;
